import { RequestInitiationConfig } from '../initiation-config/model/RequestInitiationConfig';
import { RequestInitiatorType } from '../initiation-config/model/RequestInitiatorType';

const isInitiatedBy = (
  initiationConfig: RequestInitiationConfig | undefined,
  initiationType: RequestInitiatorType,
): boolean =>
  initiationConfig ? initiationConfig.initiator === initiationType : initiationType === RequestInitiatorType.SCHEDULE;

const isInitiatedByOneOf = (
  initiationConfig: RequestInitiationConfig | undefined,
  initiationTypes: RequestInitiatorType[],
): boolean => !!initiationConfig?.initiator && initiationTypes.includes(initiationConfig.initiator);

const isInitiatedOnDemand = (initiationConfig: RequestInitiationConfig | undefined): boolean =>
  isInitiatedByOneOf(initiationConfig, [RequestInitiatorType.HCP, RequestInitiatorType.RPM_EVENT]);

const isInitiatedBySchedule = (initiationConfig: RequestInitiationConfig | undefined): boolean =>
  !initiationConfig || initiationConfig.initiator === RequestInitiatorType.SCHEDULE;

export const RequestInitiationUtil = {
  isInitiatedBy,
  isInitiatedByOneOf,
  isInitiatedOnDemand,
  isInitiatedBySchedule,
};
